<template>
    <section class="sailings">
        <header class="sailings__header">
            <h1 class="h3">All sailings are shown in local time</h1>
        </header>
        <SailingsDates v-model="date" />
        <SailingsTable :departures="data" :isLoading="isLoading ||isRefetching" />
    </section>
</template>

<script lang="ts" setup>
import { startOfToday } from "date-fns";
import { computed, ref } from "vue";
import useDeparturesQuery from "../composables/useDeparturesQuery";
import SailingsDates from "./SailingsDates.vue";
import SailingsTable from "./SailingsTable.vue";

interface Props {
    selectedRoute: number;
}

const props = defineProps<Props>();

const date = ref(startOfToday());
const route = computed(() => props.selectedRoute);

const { data, isLoading, isRefetching } = useDeparturesQuery(route, date);
</script>

<style lang="scss" scoped>
.sailings {
    display: flex;
    flex-direction: column;
    gap: 10px;

    h1 {
        font-size: 1.5rem;
        color: var(--c-text);
    }
}
</style>
